
import { defineStore } from 'pinia';
import type { SortItem } from 'vuetify/lib/components/VDataTable/composables/sort';

interface State {
  storeTableId: string;
  preSelectedFilterValues: Record<string, string[]>;
  preSelectedSearch: string;
  storedPage: number;
  storedItemsPerPage: number;
  storedSortBy: SortItem[];
}
export const tableStore = defineStore('tableStore', {
  /*
    Improvement Idea:
    Consider storing multiple table states by using a map
    where key equals tableId and value equals an object containing page, itemsPerPage, sortBy, search, filterValues.
    Delete key value pairs when not needed e.g. changing main route.
  */
  state: (): State => ({
    storeTableId: '',
    preSelectedFilterValues: { },
    preSelectedSearch: '',
    storedPage: 1,
    storedItemsPerPage: 25,
    storedSortBy: []
  }),
  actions: {
    setStoredSortBy(storeTableId: string, sortBy: SortItem ) {
      this.storeTableId = storeTableId;
      this.storedSortBy[0] = sortBy;
    },
    setStoredPageInfo(storeTableId: string, page: number, itemsPerPage: number) {
      this.storeTableId = storeTableId;
      this.storedPage = page;
      this.storedItemsPerPage = itemsPerPage;
    },
    setPreSelectedSearchValue(storeTableId: string, search: string) {
      this.storeTableId = storeTableId;
      this.preSelectedSearch = search;
    },
    setPreSelectedFilterValues(storeTableId: string, filterName: string, values: string[]) {
      this.storeTableId = storeTableId;
      this.preSelectedFilterValues[filterName] = values;
    },
    clearPreSelectedFilterValues() {
      this.preSelectedFilterValues = {};
    },
    clearStore() {
      // Store is reset inside the routers.ts everytime the main path changes
      this.storeTableId = '';
      this.storedPage = 1;
      this.storedItemsPerPage = 25;
      this.preSelectedSearch = '';
      this.preSelectedFilterValues = {};
      this.storedSortBy = [];
    }
  }
});
